import { connect } from 'react-redux'

import CrowdfundingDetailView from 'components/crowdfunding_detail_view'
import { getNewCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryDefaultCover } from 'client/lib/category'

const mapStateToProps = (state, ownProps) => {
  const campaign = ownProps.isEdit
    ? ownProps.editedCampaign
    : getNewCampaignSelector(state, ownProps)
  const defaultCategoryCover = getCategoryDefaultCover(state, campaign.category)

  return {
    campaign,
    defaultCategoryCover,
    edit: ownProps.isEdit,
    geo: state.geo,
  }
}

export default connect(mapStateToProps)(CrowdfundingDetailView)
